import React from 'react';
import { Route } from 'react-router-dom';
import { combineReducers } from 'redux';

// Reducers
import serverInstanceReducer from './ServerInstance/store/serverInstanceReducer';

// Components
import ServerInstanceList from './ServerInstance';

// Routes
export const routes = (basePath, permissions) =>
    <Route path={basePath} exact component={ServerInstanceList} />


export const reducers = combineReducers({
    servers: serverInstanceReducer
});